import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Signup.css';
import logo from "../../assets/logo.png";
import { Link } from 'react-router-dom';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  // Company details
  const [companyName, setCompanyName] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [taxId, setTaxId] = useState('');
  const [eori, setEori] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [customsOffice, setCustomsOffice] = useState('');

  const validateForm = () => {
    if (!email || !password || !firstName || !lastName || !companyName || !taxId || !city || !country) {
      setError('All fields are required');
      return false;
    }
    setError('');
    return true;
  };

  const handleSignUp = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    setLoading(true);

    try {
      const userData = {
        email,
        password,
        first_name: firstName,
        last_name: lastName,
        company: {
          nombre: companyName,
          nif: taxId,
          eori: eori,
          direccion: address,
          localidad: city,
          pais: country,
          codigo_postal: postalCode,
          aduana_habitual: customsOffice,
          correo_electronico: companyEmail || email
        }
      };
      
      const url = `https://${process.env.REACT_APP_DOCS_API_KEY}/api/auth/register`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify(userData),
      });

      setLoading(false);

      const responseData = await response.json();
      navigate('/login');
    } catch (error) {
      setLoading(false);
      console.error('Error:', error);
      setError('An error occurred. Please try again later.');
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSignUp}>
        <div className="form-group">
          <div className='flex w-full justify-center'>
            <img src={logo} alt="Logo" className="logo-image !h-9" />
          </div>
        </div>
        <h1 className='text-4xl font-bold mb-8 mt-4 text-center font-gdSage'>Create your account</h1>
        <p className='mt-8 text-gray-500 mb-2 text-sm'>Personal Details</p>
        <div className='flex gap-4'>
          <div className="form-group flex-1">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              className="form-input border"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="form-group flex-1">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              className="form-input border"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
        </div>
        <div className='flex gap-4'>
          <div className="form-group flex-1">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className="form-input border"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group flex-1">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              className="form-input border"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
        </div>
        
        <p className='mt-4 text-gray-500 mb-2 text-sm'>Company Details</p>

        <div className='flex gap-4 '>
          <div className="form-group flex-1">
            <label htmlFor="companyName">Company Name</label>
            <input
              type="text"
              id="companyName"
              className="form-input border"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </div>
          <div className="form-group flex-1">
            <label htmlFor="companyEmail">Company Email</label>
            <input
              type="email"
              id="companyEmail"
              className="form-input border"
              value={companyEmail}
              onChange={(e) => setCompanyEmail(e.target.value)}
            />
          </div>
        </div>

        <div className='flex gap-4'>
          <div className="form-group flex-1">
            <label htmlFor="taxId">NIF</label>
            <input
              type="text"
              id="taxId"
              className="form-input border"
              value={taxId}
              onChange={(e) => setTaxId(e.target.value)}
              required
            />
          </div>
          <div className="form-group flex-1">
            <label htmlFor="eori">EORI</label>
            <input
              type="text"
              id="eori"
              className="form-input border"
              value={eori}
              onChange={(e) => setEori(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="address">Address</label>
          <input
            type="text"
            id="address"
            className="form-input border"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
          />
        </div>

        <div className='flex gap-4'>
          <div className="form-group flex-1">
            <label htmlFor="city">City</label>
            <input
              type="text"
              id="city"
              className="form-input border"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              required
            />
          </div>
          <div className="form-group flex-1">
            <label htmlFor="postalCode">Postal Code</label>
            <input
              type="text"
              id="postalCode"
              className="form-input border"
              value={postalCode}
              onChange={(e) => setPostalCode(e.target.value)}
              required
            />
          </div>
        </div>
        <div className='flex gap-4'>
          <div className="form-group flex-1">
            <label htmlFor="country">Country</label>
            <input
              type="text"
              id="country"
              className="form-input border"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              required
            />
          </div>
          <div className="form-group flex-1">
            <label htmlFor="customsOffice">Customs Office</label>
            <input
              type="text"
              id="customsOffice"
              className="form-input border"
              value={customsOffice}
              onChange={(e) => setCustomsOffice(e.target.value)}
            />
          </div>
        </div>
        {error && <p className="mb-4 text-red-500">{error}</p>}
        <div className='flex justify-end'>
          <button type="submit" disabled={loading} className='mt-4 login-button py-4 px-4 mr-0 w-full'>
            {loading ? 'Signing up...' : 'Sign Up'}
          </button>
        </div>
        <div className='flex justify-center mt-4'>
          <p>Already have an account? <Link to="/login" className='text-primary'>Log in</Link></p>
        </div>
      </form>
    </div>
  );
};

export default SignUp;